import lKScreenStyle from "./LKCallScreen.module.css";
import AudioURLPlayback from "./AudioURLPlayback";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";

export default function BackgroundMusic(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'backgroundMusic' });
    const [audioFile, setAudioFile] = useState()

    return <div className={props.folded ? lKScreenStyle.backgroundMusicContainerFolded : lKScreenStyle.backgroundMusicContainer}>
            <span
                style={{display: "flex", justifyContent: "center", cursor: "s-resize", width: "100%"}}

            >{t('backgroundMusic')}</span>
        {audioFile && <span style={{display: "flex", justifyContent: "center", cursor: "s-resize", width: "100%", fontSize: "12px", fontWeight:"lighter"}}>{audioFile.name}</span>}
        {audioFile && <AudioURLPlayback url={URL.createObjectURL(audioFile)} isGroupGame={false}/>}
        <div
            className={lKScreenStyle.backgroundAudioButton}
            onClick={() => {
                if (audioFile) {
                    setAudioFile(null)
                }
            }}
        >
            {audioFile && <span >{t('stop')}</span>}
            {!audioFile && <label
                htmlFor={"background-music-file-input"}

            > {audioFile ? t('stop') : t('selectFile')} </label>}
            {!audioFile && <input style={{display: "none"}} type="file" id="background-music-file-input" accept={"audio/mpeg"} multiple={false} onChange={(e) => setAudioFile(e.target.files[0])}/>}
        </div>

    </div>
}